import React from 'react'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import globalvariables from '@globalvariables'
import { checkValidEmail } from './util/helpers'

const onFormSubmitValidateRecaptcha = async (
  event: React.SyntheticEvent,
  onSetSubmitting: React.Dispatch<React.SetStateAction<boolean>>,
  onSetSubmitResult: React.Dispatch<React.SetStateAction<string>>,
  onSetNewsletterSubmitResult: React.Dispatch<React.SetStateAction<string>>,
  onSetSuccess: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  event.preventDefault()
  const form = event.target as HTMLFormElement
  const formData = new FormData(form)
  const newsletterSignup =
    (
      form.elements.namedItem('newsletter_signup') as
      | HTMLInputElement
      | undefined
    )?.checked ?? false
  const emailElement = form.elements.namedItem('email') as HTMLInputElement
  const email = emailElement?.value ?? ''
  const companyEmailElement = form.elements.namedItem(
    'company_email',
  ) as HTMLInputElement
  const companyEmail = companyEmailElement?.value ?? ''

  const email_address = email || companyEmail
  const email_address_element = email ? emailElement : companyEmailElement

  if (!checkValidEmail(email_address)) {
    email_address_element.setCustomValidity(
      'Please enter your work email. Free email domains are not accepted',
    )
    email_address_element.reportValidity()
    return
  }

  const company =
    (form.elements.namedItem('company_name') as HTMLInputElement | undefined)
      ?.value ?? ''
  const firstName =
    (form.elements.namedItem('first_name') as HTMLInputElement | undefined)
      ?.value ?? ''
  const lastName =
    (form.elements.namedItem('last_name') as HTMLInputElement | undefined)
      ?.value ?? ''

  const recaptchaField = form.elements.namedItem(
    'g-recaptcha-response',
  ) as HTMLTextAreaElement
  // Temporarily to true for testing
  const hasRecaptcha = !!recaptchaField.value
  // const hasRecaptcha = !!recaptchaField.value
  if (!hasRecaptcha) {
    // setTimeout so the script doesn't block
    setTimeout(() => alert('Please confirm you are not a robot.'), 1)
  } else {
    try {
      // @ts-expect-error - formData is a FormData object
      const body = new URLSearchParams(formData).toString()
      onSetSuccess(false)
      onSetSubmitting(true)
      onSetSubmitResult('')
      onSetNewsletterSubmitResult('')
      const result = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      })
      if (result.status === 200) {
        onSetSubmitResult(globalvariables.FORM_SUCCESSFUL_MSG)
        onSetSuccess(true)
        if (newsletterSignup && email_address) {
          const result = await addToMailchimp(email_address, {
            MERGE1: firstName,
            MERGE2: lastName,
            MERGE5: company,
          })
          onSetNewsletterSubmitResult(result.msg)
        }
        onSetSubmitting(false)
      } else {
        onSetSubmitResult(globalvariables.FORM_SUCCESSFUL_ERROR)
        onSetSubmitting(false)
      }
    } catch (error) {
      console.log({ error })
      onSetSubmitResult(globalvariables.FORM_SUCCESSFUL_ERROR)
      onSetSubmitting(false)
    }
  }
}

export { onFormSubmitValidateRecaptcha }
